import app from 'flarum/forum/app';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPage from 'flarum/forum/components/UserPage';
import { extend } from 'flarum/common/extend';
import PlayersPage from './PlayersPage';
import PlayerDirectoryPage from './PlayerDirectoryPage';
import PlayerProfilePage from './PlayerProfilePage';
import EditPlayerPage from './EditPlayerPage';
import MatchesPage from './MatchesPage';
import EditMatchBasicPage from './EditMatchBasicPage';
import EditMatchScorePage from './EditMatchScorePage';
import EditMatchParticipantesPage from './EditMatchParticipantesPage';
import RivalsPage from './RivalsPage';
import EditRivalPage from './EditRivalPage';
import UploadEscudosPage from './UploadEscudosPage';
import CompetitionsPage from './CompetitionsPage';
import TaldezainaPage from '../lineup/TaldezainaPage';
import TaldezainaTasksPage from '../taldezaina/TaldezainaTasksPage';
import TaldezainaNotificationsPage from '../lineup/TaldezainaNotificationsPage';
import TaldezainaSecurityQuestionsPage from '../lineup/TaldezainaSecurityQuestionsPage';
import GorbeaTaldezainaPage from '../gorbea/GorbeaTaldezainaPage';
import MundialTaldezainaPage from '../mundial/MundialTaldezainaPage';
import PlayerBirthdayPage from './PlayerBirthdayPage';
export default function extendMatchRatingAdmin(app) {
  app.routes['bizkaitarra-lineup.birthday'] = {
    path: '/urtebetetzea/:slug',
    component: PlayerBirthdayPage
  };
  app.routes['bizkaitarra-lineup.players'] = {
    path: '/jugadores',
    component: PlayerDirectoryPage
  };
  app.routes['bizkaitarra-lineup.player-profile'] = {
    path: '/jugador/:slug',
    component: PlayerProfilePage
  };
  app.routes['bizkaitarra-lineup.player-profile-alt'] = {
    path: '/jugadores/:slug',
    component: PlayerProfilePage
  };
  app.routes['bizkaitarra-lineup.taldezaina'] = {
    path: '/taldezaina',
    component: TaldezainaPage
  };
  app.routes['bizkaitarra-lineup.taldezaina.tasks'] = {
    path: '/taldezaina/tareas',
    component: TaldezainaTasksPage
  };
  app.routes['bizkaitarra-lineup.taldezaina.security-questions'] = {
    path: '/taldezaina/preguntas-seguridad',
    component: TaldezainaSecurityQuestionsPage
  };
  app.routes['bizkaitarra-lineup.taldezaina.notifications'] = {
    path: '/taldezaina/notificaciones',
    component: TaldezainaNotificationsPage
  };
  app.routes['bizkaitarra-lineup.taldezaina.notifications.alt'] = {
    path: '/taldezaina/notifications',
    component: TaldezainaNotificationsPage
  };
  app.routes['bizkaitarra-lineup.taldezaina.notifications.legacy'] = {
    path: '/taldezainak/notifications',
    component: TaldezainaNotificationsPage
  };
  app.routes['bizkaitarra-lineup.taldezaina.gorbea'] = {
    get path() {
      const slug = app.forum && app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
      const url = slug === 'real-sociedad' ? 'pastor-txindoki' : 'pastor-gorbea';
      return "/taldezaina/".concat(url);
    },
    component: GorbeaTaldezainaPage
  };
  app.routes['bizkaitarra-lineup.taldezaina.mundial'] = {
    path: '/taldezaina/mundial-2026',
    component: MundialTaldezainaPage
  };
  app.routes['bizkaitarra-lineup.taldezaina.players'] = {
    path: '/taldezaina/jugadores',
    component: PlayersPage
  };
  app.routes['bizkaitarra-lineup.players.edit'] = {
    path: '/taldezaina/jugadores/editar/:id',
    component: EditPlayerPage
  };
  app.routes['bizkaitarra-lineup.matches'] = {
    path: '/taldezaina/partidos',
    component: MatchesPage
  };
  app.routes['bizkaitarra-lineup.matches.create'] = {
    path: '/taldezaina/partidos/crear',
    component: EditMatchBasicPage
  };
  app.routes['bizkaitarra-lineup.matches.edit'] = {
    path: '/taldezaina/partidos/editar/:id',
    component: EditMatchBasicPage
  };
  app.routes['bizkaitarra-lineup.matches.edit-score'] = {
    path: '/taldezaina/partidos/editar-resultado/:id',
    component: EditMatchScorePage
  };
  app.routes['bizkaitarra-lineup.matches.edit-participantes'] = {
    path: '/taldezaina/partidos/editar-participantes/:id',
    component: EditMatchParticipantesPage
  };
  app.routes['bizkaitarra-lineup.rivals'] = {
    path: '/taldezaina/rivales',
    component: RivalsPage
  };
  app.routes['bizkaitarra-lineup.rivals.create'] = {
    path: '/taldezaina/rivales/crear',
    component: EditRivalPage
  };
  app.routes['bizkaitarra-lineup.rivals.edit'] = {
    path: '/taldezaina/rivales/editar/:id',
    component: EditRivalPage
  };
  app.routes['bizkaitarra-lineup.rivals.escudos'] = {
    path: '/taldezaina/rivales/escudos',
    component: UploadEscudosPage
  };
  app.routes['bizkaitarra-lineup.taldezaina.competitions'] = {
    path: '/taldezaina/competiciones',
    component: CompetitionsPage
  };
  extend(UserPage.prototype, 'navItems', function (items) {
    if (app.forum.attribute('canManagePlayers') && this.user === app.session.user) {
      items.add('edit-players', m(LinkButton, {
        href: app.route('bizkaitarra-lineup.taldezaina'),
        icon: 'fas fa-user-shield'
      }, app.translator.trans('bizkaitarra-lineup.forum.players.edit_players_link')), 80);
    }
  });
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/extendMatchRatingAdmin', extendMatchRatingAdmin);